import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import ErrorTemplate from '../ErrorTemplate';

const messages = defineMessages({
  restrictedContent: {
    id: 'Restricted Content',
    defaultMessage: 'Restricted Content',
  },
});

const Unauthorized = () => {
  const intl = useIntl();

  return (
    <ErrorTemplate
      imageSrc="/errors/error403.png"
      imageAlt={intl.formatMessage(messages.restrictedContent)}
      title={
        <FormattedMessage
          id="Restricted Content"
          defaultMessage="Restricted Content"
        />
      }
      description={
        <FormattedMessage
          id="Authentication is required to view this page. If you believe you are receiving this message incorrectly, please contact the {site_admin}."
          defaultMessage="Authentication is required to view this page. If you believe you are receiving this message incorrectly, please contact the {site_admin}."
          values={{
            site_admin: (
              <Link className="text-bold" to="/contact-form">
                <FormattedMessage
                  id="site administration"
                  defaultMessage="site administration"
                />
              </Link>
            ),
          }}
        />
      }
    />
  );
};

export default withServerErrorCode(401)(Unauthorized);
